/**
 * Generates a random 12-character alphanumeric password with at least one uppercase letter
 * @returns {string} Generated password
 */
export const generateRandomPassword = (): string => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const allChars = lowercase + uppercase + numbers;
  
  let password = '';
  
  // Ensure at least one uppercase letter
  password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
  
  // Fill the rest with random characters
  for (let i = 1; i < 12; i++) {
    password += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }
  
  // Shuffle the password to randomize the position of the uppercase letter
  return password.split('').sort(() => Math.random() - 0.5).join('');
};

/**
 * Password validation rules
 */
export const passwordRules = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumbers: true,
  description: 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number.'
};

/**
 * Validates a password against the rules
 * @param {string} password - Password to validate
 * @returns {boolean} Whether the password is valid
 */
export const validatePassword = (password: string): boolean => {
  if (password.length < passwordRules.minLength) return false;
  if (passwordRules.requireUppercase && !/[A-Z]/.test(password)) return false;
  if (passwordRules.requireLowercase && !/[a-z]/.test(password)) return false;
  if (passwordRules.requireNumbers && !/[0-9]/.test(password)) return false;
  return true;
};
